import React from 'react';
import { Navigate } from 'react-router-dom';
import { DEFAULT_PATHS } from '../routing/paths.ts';
import { useOrgModuleAccess } from '../hooks/useOrgModuleAccess.ts';

type OrgAdminRouteProps = {
  children: React.ReactNode;
  /** When true, also require org AI integration (same as sidebar AI Activity). */
  requireOwnAIIntegration?: boolean;
};

const OrgAdminRoute: React.FC<OrgAdminRouteProps> = ({
  children,
  requireOwnAIIntegration = false,
}) => {
  const { data: moduleAccess, isSuccess, isLoading, isError } = useOrgModuleAccess();

  if (isLoading) {
    return (
      <div className="flex min-h-[12rem] items-center justify-center px-8 py-12 text-sm text-gray-500">
        Loading…
      </div>
    );
  }

  if (isError || !isSuccess || moduleAccess?.role !== 'org_admin') {
    return <Navigate to={DEFAULT_PATHS.TENANT_LANDING} replace />;
  }

  if (requireOwnAIIntegration && !moduleAccess?.has_own_ai_credentials) {
    return <Navigate to={DEFAULT_PATHS.TENANT_LANDING} replace />;
  }

  return <>{children}</>;
};

export default OrgAdminRoute;
